module.exports = __webpack_public_path__ + "static/payment_gateway-62e2523008d8d11fd777f9962b3f9d93.svg";